// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'normalize.css/normalize.css' // 保护有价值的默认值，修复浏览器的bug，优化css可用性
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import * as filters from './filters'
import router from './router'
import echarts from 'echarts'
import store from './store'
import './utils/rem.js'
import '../theme/index.css'
require('./styles/global.scss')
// 注册全局时的过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(Element)
// Vue.prototype.$pinyinmatch = PinyinMatch
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})
